import request from '@/utils/request'

export default {
    queryList: function (query) {
        return request({
            url: 'benefit/queryList',
            method: 'post',
            data: query
        });
    },
}
